import { Route, Routes } from "react-router-dom";
import { routes, RouteConfig } from "@/config/routes";

export const AppRoutes = () => {
  const renderRoutes = (prefix: string = "") => 
    routes.map(({ path, element: Element }: RouteConfig) => (
      <Route 
        key={`${prefix}${path}`} 
        path={`${prefix}${path}`} 
        element={<Element />} 
      />
    ));

  return (
    <Routes>
      {/* Indian region routes */}
      {renderRoutes("/in/")}
      {/* Default routes */}
      {renderRoutes("/")}
    </Routes>
  );
};